import { RoundingMethod } from "../../../../../../../redux/constants/OrdersPage/order";

import type { Order } from "../../../../../../../services";
import type { ColorState } from "../../../../../../../redux/reducers/settings/colors";

const cellProcessing = (
	item?: Order.Model,
	colors?: ColorState,
	currencyFromGlobal?: string,
): cellProcessing.Retval => {
	if (!item) {
		return {
			content: "0",
			backgroundColor: "#ffffff",
			price: 0,
			currency: "",
		};
	}

	const rounding = item.cost?.settings?.rounding ?? {};
	const {
		multiple = { value: 0, active: false },
		method = RoundingMethod.GENERAL,
		precision = 2,
	} = rounding;

	const priceValue = item.cost?.value ?? 0;
	const currency = currencyFromGlobal ?? "";

	const getRoundedPriceNumber = (): number => {
		let processed = priceValue;
		const multiplier = 10 ** precision;
		if (multiple.active && multiple.value !== 0) {
			processed /= multiple.value;
		} else {
			processed *= 10 ** precision;
		}

		switch (method) {
			case RoundingMethod.CEIL:
				processed = Math.ceil(processed * multiplier) / multiplier;
				break;
			case RoundingMethod.FLOOR:
				processed = Math.floor(processed * multiplier) / multiplier;
				break;
			default:
				processed = Math.round(processed * multiplier) / multiplier;
		}

		if (multiple.active && multiple.value !== 0) {
			processed *= multiple.value;
		} else {
			processed /= 10 ** precision;
		}

		return Number(processed.toFixed(precision));
	};

	const price = getRoundedPriceNumber();

	return {
		content: `${price} ${currency}`,
		backgroundColor: colors?.[item.paymentType] || "#ffffff",
		price,
		currency,
	};
};

declare namespace cellProcessing {
	interface Retval {
		content: string;
		backgroundColor: string;
		price: number;
		currency: string;
	}
}

export default cellProcessing;
